import { type IndustryCodeDto, industryCodeDtoMap } from "app/pages/sales-intelligence/domain/industry/types/codes";
import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import { hasSameIndustryCodesObject } from "app/pages/sales-intelligence/domain/industry/utils/operations";
import type { ISiteTagsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { hasSameSiteTagsObject } from "app/pages/sales-intelligence/domain/leads/utils/site-tags-operations";

import { collectUnavailableInclusionValues } from "./collectUnavailableInclusionValues";

export const getUnavailableSiteTagValues = (
    conditions: readonly ISiteTagsDto[],
    selected: ISiteTagsDto | null,
): readonly string[] =>
    collectUnavailableInclusionValues(conditions, selected, hasSameSiteTagsObject, (condition) => condition.values);

export const getUnavailableIndustryCodes = (
    conditions: readonly IIndustryCodesFilterDto[],
    selected: IIndustryCodesFilterDto | null,
    codeType: IndustryCodeDto,
): readonly string[] =>
    collectUnavailableInclusionValues(conditions, selected, hasSameIndustryCodesObject, (condition) =>
        codeType === industryCodeDtoMap.naics ? condition.naicsCodes : condition.sicCodes,
    );
